module.exports = "float PI_2 = 1.5707963268;"